import { createSelector } from 'reselect';

// Config
import { DELIVERY_DETAILS_FORM_ID } from '../../constants/deliveryConstants';
import {
  getCreateAddressAPICallActiveSelector,
  getDeliveryProceedingToPaymentSelector,
  getPutDeliveryAddressApiCallActiveSelector,
} from '../../redux/reducers/delivery/deliverySelector';
import { getAddressBookAPICallActiveSelector } from '../../redux/reducers/addressBook/addressBookSelector';
import {
  getClickAndCollectProceedingToPaymentSelector,
  getCollectionPointSearchActiveSelector,
  getCollectionPointSearchCompleteSelector,
} from '../../redux/reducers/click-and-collect/clickAndCollectSelector';
import { getFormSelector } from '../../redux/reducers/form/formSelector';
import { getRouterLocationPathname } from '../../redux/reducers/router/routerSelector';
import { isFormMounted } from '../../utils';
import { CLICK_AND_COLLECT_FORM_ID } from '../../utils/form/configs/clickAndCollect';
import { COLLECTOR_DETAILS_FORM_ID } from '../../utils/form/configs/collectorDetails';

const goToPaymentState = createSelector(
  [
    getFormSelector,
    getCollectionPointSearchCompleteSelector,
    getRouterLocationPathname,
    getPutDeliveryAddressApiCallActiveSelector,
    getCreateAddressAPICallActiveSelector,
    getAddressBookAPICallActiveSelector,
    getDeliveryProceedingToPaymentSelector,
    getCollectionPointSearchActiveSelector,
    getClickAndCollectProceedingToPaymentSelector,
  ],
  (
    form,
    collectionPointSearchComplete,
    pathname,
    putDeliveryAddressApiCallActive,
    createAddressAPICallActive,
    getAddressBookAPICallActive,
    deliveryProceedingToPayment,
    collectionPointSearchActive,
    clickAndCollectProceedingToPayment,
  ) => ({
    deliveryDetailsFormMounted: !!Object.keys(form || []).find(formId => formId.includes(DELIVERY_DETAILS_FORM_ID)),
    enableButton: (
      !putDeliveryAddressApiCallActive &&
      !createAddressAPICallActive &&
      !getAddressBookAPICallActive &&
      !deliveryProceedingToPayment &&
      !collectionPointSearchActive &&
      !clickAndCollectProceedingToPayment
    ),
    collectorDetailsFormMounted: isFormMounted(form?.[COLLECTOR_DETAILS_FORM_ID]),
    collectionSearchFormMounted: isFormMounted(form?.[CLICK_AND_COLLECT_FORM_ID]),
    collectionPointSearchComplete,
    pathname,
  }),
);

export default goToPaymentState;
